<template>
    <Teleport to="body">
        <component
            v-for="modal in modals"
            :key="modal.id"
            :is="modal.component"
            v-bind="modal.props"
            :modelValue="modal.visible"
            @confirm="data => onConfirm(modal.id, data)"
            @cancel="() => onCancel(modal.id)"
            @close="() => onCancel(modal.id)"
            @update:modelValue="val => onUpdateModelValue(modal.id, val)"
        />
    </Teleport>
</template>

<script>
import { computed } from 'vue';
import { modalState, closeModal } from '../utils/modalState';

export default {
    name: 'ModalContainer',

    setup() {
        // Access the reactive modalState directly in setup, not through data()
        const modals = computed(() => modalState.stack);

        const onConfirm = (id, data) => {
            closeModal(id, data, false);
        };

        const onCancel = id => {
            closeModal(id, undefined, true);
        };

        const onUpdateModelValue = (id, val) => {
            if (!val) {
                closeModal(id, undefined, true);
            }
        };

        return {
            modals,
            onConfirm,
            onCancel,
            onUpdateModelValue
        };
    }
};
</script>
